import { Component, inject, OnInit } from '@angular/core';
import { CertificadoResponse } from 'app/shared/models/ei-models';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { CertificadoService } from 'app/shared/services/edduca-imob';
import { GlobalService } from 'app/shared/services/core';

interface CertificadosPorTrilha {
  trilhaNome: string;
  certificados: CertificadoResponse[];
}

@Component({
  selector: 'app-certificados',
  standalone: true,
  imports: [DefaultComponentsModule],
  templateUrl: './certificados.component.html',
  styleUrl: './certificados.component.scss'
})
export class CertificadosComponent implements OnInit {
  private certificadoService = inject(CertificadoService);
  private _gs = inject(GlobalService);

  certificados: CertificadoResponse[] = [];
  certificadosPorTrilha: CertificadosPorTrilha[] = [];
  loading = true;

  ngOnInit() {
    const userId = this._gs.getIdUserLogged();
    this.certificadoService.listarCertificadosUsuario(userId).subscribe({
      next: (res) => {
        this.certificados = res;
        this.agruparCertificadosPorTrilha();
        this.loading = false;
      },
      error: () => {
        this.certificados = [];
        this.certificadosPorTrilha = [];
        this.loading = false;
      }
    });
  }

  agruparCertificadosPorTrilha() {
    const trilhasMap = new Map<string, CertificadoResponse[]>();
    
    this.certificados.forEach(cert => {
      const trilha = cert.trilhaNome || 'Sem Trilha';
      if (!trilhasMap.has(trilha)) {
        trilhasMap.set(trilha, []);
      }
      trilhasMap.get(trilha)!.push(cert);
    });

    this.certificadosPorTrilha = Array.from(trilhasMap.entries()).map(([trilhaNome, certificados]) => ({
      trilhaNome,
      certificados
    }));
  }

  downloadCertificado(certificado: CertificadoResponse) {
    this.certificadoService.downloadCertificado(certificado.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `certificado-${certificado.moduloNome}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this._gs.notification.error('Erro ao baixar certificado');
      }
    });
  }
}
